import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LandingComponent} from './landing/landing.component';
import {AccountHistoryComponent} from './history/account-history/account-history.component';
import {ProductDetailsComponent} from './product/product-details/product-details.component';
import {ShoppingCartComponent} from './shopping-cart/shopping-cart/shopping-cart.component';
import {OrderSummaryComponent} from './history/order-summary/order-summary.component';
import {AvailableDownloadsComponent} from './history/available-downloads/available-downloads.component';
import {
  DownloadWithoutPurchaseIndexComponent
} from './download-without-purchase/download-without-purchase-index/download-without-purchase-index.component';
import {LoadUserGuard} from '@uofu-uss-aux/software-catalog-ng-core';
import {
  DownloadWithoutPurchaseDetailsComponent
} from './download-without-purchase/download-without-purchase-details/download-without-purchase-details.component';
import {ProductsComponent} from './product/products/products.component';
import {AuthenticatedGuard} from '@uofu-uss/ngx-auth';
import {AdobeCcLandingComponent} from './third-party/adobe/adobe-cc-landing/adobe-cc-landing.component';
import {AdobeExpressLandingComponent} from './third-party/adobe/adobe-express-landing/adobe-express-landing.component';
import {AdobeCcRequestComponent} from './third-party/adobe/adobe-cc-request/adobe-cc-request.component';
import {ThirdPartyWrapperComponent} from './third-party/third-party-wrapper/third-party-wrapper.component';

export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'products',
    component: ProductsComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'account-history',
    component: AccountHistoryComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'downloads',
    component: AvailableDownloadsComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'download-files',
    component: DownloadWithoutPurchaseIndexComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'download-without-purchase/:product-id/:offering-version',
    component: DownloadWithoutPurchaseDetailsComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'product/:id',
    component: ProductDetailsComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'cart',
    component: ShoppingCartComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'order-summary',
    component: OrderSummaryComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'licensing/:vendorName/:name',
    component: ThirdPartyWrapperComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'adobe',
    redirectTo: 'adobe/express',
    pathMatch: 'full',
  },
  {
    path: 'adobe/express',
    component: AdobeExpressLandingComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'adobe/creative-cloud',
    component: AdobeCcLandingComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: 'adobe/creative-cloud/request',
    component: AdobeCcRequestComponent,
    canActivate: [AuthenticatedGuard, LoadUserGuard],
  },
  {
    path: '**',
    redirectTo: '',
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
